import { Component } from '@nicolas-riciotti/light2';

export default class BlockEdits extends Component {
  created() {
    this.sendPrompt = this.sendPrompt.bind(this);
  }

  attached() {
    this.$button = this.querySelector('[data-send-button]');
    if (!this.$button) return;
    this.$button.addEventListener('click', this.sendPrompt);
  }

  detached() {
    this.$button?.removeEventListener('click', this.sendPrompt);
  }

  sendPrompt() {
    this.classList.add('is-edited');
  }

}

customElements.define('block-edits', BlockEdits);